export { default } from './StockFilterTextArea';
